import React, { Component } from 'react';
import Button from '../common/Button';
import SliderHeader from './SliderHeader';
import JobDetails from './JobDetails';
import Quotes from './Quotes';
import Draggable from 'react-draggable';
import { findIndex } from 'lodash';
import PageLoader from '../common/PageLoader';
import CustomModal from '../common/CustomModal';
import { Modal } from 'react-bootstrap';
import CustomScroll from 'react-custom-scroll';
import TextInput from '../common/TextInput';

export default class JobSliderView extends Component {
  constructor(props) {
    super(props)
    this.nextSliderCallback = this.nextSliderCallback.bind(this);
    this.previousSliderCallback = this.previousSliderCallback.bind(this);
    let showNextButton = true;
    let showPreviousButton = true;
    if (props.jobs) {
      const sliderItems = props.jobs.length;
      if (sliderItems > 1) {
        const currentSliderIndex = (props.jobStatus == 'waiting') ? findIndex(props.jobs, { 'id': props.currentSliderId }) : findIndex(props.jobs, { 'userbookingrequestId': props.currentSliderId });
        if (!(props.jobs[currentSliderIndex + 1])) {
          showNextButton = false
        }
        if (!(props.jobs[currentSliderIndex - 1])) {
          showPreviousButton = false
        }
      } else {
        showNextButton = false;
        showPreviousButton = false;
      }
    }
    this.state = {
      showDeclineModal: false,
      currentSliderId: props.currentSliderId,
      isSliderLoaded: false,
      showNextButton: showNextButton,
      showPreviousButton: showPreviousButton,
      declineReason: '',
      showDeclineReasonErrTxt: false,
    };
    if (props.jobRequestReducer.jobList[props.currentSliderId] && props.jobRequestReducer.jobList[props.currentSliderId].requeststatus && props.jobRequestReducer.jobList[props.currentSliderId].requeststatus.name && (props.jobRequestReducer.jobList[props.currentSliderId].requeststatus.name == 'Waiting') && !props.jobRequestReducer.jobList[props.currentSliderId].alreadySeen) {
      props.actions.updateNewCount(props.currentSliderId);
    }
  }
  async componentWillMount() {
    if (this.props.jobRequestReducer.jobList[this.state.currentSliderId]) {
      this.setState({ 'isSliderLoaded': true });
    } else {
      await this.props.actions.getPostedJobById(this.state.currentSliderId, this.props.jobStatus);
    }
    this.props.actions.getBusinessTax();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.jobRequestReducer && nextProps.jobRequestReducer.isSliderLoaded && !this.state.isSliderLoaded) {
      this.setState({ 'isSliderLoaded': true });
    }


  }
  declineJob() {
    if (!this.state.showDeclineReasonErrTxt) {
      this.props.actions.declineAJob(this.state.currentSliderId, this.props.jobStatus, this.state.declineReason);
      this.setState({ showDeclineModal: false });
      this.props.modalCloseCallBack();
    }
  }

  onDeclineReasonChange (text) {
    let txtLength = text.length;
    this.setState({
      declineReason: text,
      showDeclineReasonErrTxt: txtLength > 200 ? true : false,
    });
  }

  nextSliderCallback() {
    if (this.props.jobs) {
      const sliderItems = this.props.jobs.length;
      if (sliderItems > 1) {
        const currentSliderIndex = (this.props.jobStatus == 'waiting') ? findIndex(this.props.jobs, { 'id': this.state.currentSliderId }) : findIndex(this.props.jobs, { 'userbookingrequestId': this.state.currentSliderId });
        if (this.props.jobs[currentSliderIndex + 1]) {
          const currentSliderId = (this.props.jobStatus == 'waiting') ? this.props.jobs[currentSliderIndex + 1].id : this.props.jobs[currentSliderIndex + 1].userbookingrequestId;
          const nextSlider = this.props.jobs[currentSliderIndex + 2];
          if (this.props.jobRequestReducer.jobList[currentSliderId] && this.props.jobRequestReducer.jobList[currentSliderId].requeststatus && this.props.jobRequestReducer.jobList[currentSliderId].requeststatus.name && (this.props.jobRequestReducer.jobList[currentSliderId].requeststatus.name == 'Waiting') && !this.props.jobRequestReducer.jobList[currentSliderId].alreadySeen) {
            this.props.actions.updateNewCount(currentSliderId);
          }
          this.setState({
            'currentSliderId': currentSliderId,
            'isSliderLoaded': true,
            showNextButton: nextSlider ? true : false,
            showPreviousButton: true
          });
          let jobStatus = undefined;
          if (this.props.fromJobHistory) {
            jobStatus = this.props.jobs[currentSliderIndex + 1] ? this.props.jobs[currentSliderIndex + 1].jobStatus : undefined;
          } else {
            jobStatus = this.props.jobStatus;
          }
          if (this.props.jobRequestReducer.jobList[currentSliderId]) {
            this.setState({ 'isSliderLoaded': true });
          } else {
            this.props.actions.getPostedJobById(currentSliderId, jobStatus);
          }
        }
      }
    }
  }
  previousSliderCallback() {
    if (this.props.jobs) {
      const sliderItems = this.props.jobs.length;
      if (sliderItems > 1) {
        const currentSliderIndex = (this.props.jobStatus == 'waiting') ? findIndex(this.props.jobs, { 'id': this.state.currentSliderId }) : findIndex(this.props.jobs, { 'userbookingrequestId': this.state.currentSliderId });
        if (this.props.jobs[currentSliderIndex - 1]) {
          const currentSliderId = (this.props.jobStatus == 'waiting') ? this.props.jobs[currentSliderIndex - 1].id : this.props.jobs[currentSliderIndex - 1].userbookingrequestId;
          const previousSlider = this.props.jobs[currentSliderIndex - 2];
          if (this.props.jobRequestReducer.jobList[currentSliderId] && this.props.jobRequestReducer.jobList[currentSliderId].requeststatus && this.props.jobRequestReducer.jobList[currentSliderId].requeststatus.name && (this.props.jobRequestReducer.jobList[currentSliderId].requeststatus.name == 'Waiting') && !this.props.jobRequestReducer.jobList[currentSliderId].alreadySeen) {
            this.props.actions.updateNewCount(currentSliderId);
          }
          this.setState({
            'currentSliderId': currentSliderId,
            'isSliderLoaded': false,
            showNextButton: true,
            showPreviousButton: previousSlider ? true : false
          });
          let jobStatus = undefined;
          if (this.props.fromJobHistory) {
            jobStatus = this.props.jobs[currentSliderIndex - 1] ? this.props.jobs[currentSliderIndex - 1].jobStatus : undefined;
          } else {
            jobStatus = this.props.jobStatus;
          }
          if (this.props.jobRequestReducer.jobList[currentSliderId]) {
            this.setState({ 'isSliderLoaded': true });
          } else {
            this.props.actions.getPostedJobById(currentSliderId, jobStatus);
          }
        }
      }
    }
  }

  onChangeChassis(value) {
    console.log('What is chassis ', value);
  }

  render() {
    const {
            nextSlide,
      prevSlide,
      jobRequestReducer,
      commonReducer,
      jobStatus,
      actions,
      router
        } = this.props;
    let vat = commonReducer && commonReducer.taxInfo &&  commonReducer.taxInfo.length && commonReducer.taxInfo ?  commonReducer.taxInfo[0].value: 0 ;

    const requestDetails = jobRequestReducer.jobList[this.state.currentSliderId];
    console.log("requestDetails popup= ", requestDetails);
    console.log("####jobRequestReducer##", jobRequestReducer);
    const unableToFetchPostedJobById = jobRequestReducer.unableToFetchPostedJobById;
    return (
      <div>
        {/*<Button btnType="submit" btnSize="sm" fontSize={15} backgroundColor="red" label={"Open"} btnCallBack={this.toggleHidden.bind(this)} />*/}
        <div className="jobSlider " key={this.state.currentSliderId}>
          <Draggable handle=".jm-header">
            <div className="jobSlider-modal">

              {(this.state.isSliderLoaded && requestDetails) ?
                <div>
                  <SliderHeader
                    router={router}
                    actions={actions}
                    requestDetails={requestDetails}
                    modalClose={this.props.modalCloseCallBack}
                    showNextButton={this.state.showNextButton}
                    showPreviousButton={this.state.showPreviousButton}
                    nextSliderCallback={this.nextSliderCallback}
                    previousSliderCallback={this.previousSliderCallback}
                    declineAJobCallback={() => {
                      this.setState({ showDeclineModal: true })
                    }}/>
                  <div className="jm-body">
                    <CustomScroll heightRelativeToParent="calc(100%)" allowOuterScroll={true}>
                      <div className="row">
                        <div className="col-md-6 jobSlider-left">
                          <JobDetails
                            jobStatus={jobStatus}
                            requestDetails={requestDetails}
                            noeditchassis={true}
                            chassisNumberChange= {this.onChangeChassis.bind(this)}
                          />
                        </div>
                        <div className="col-md-6 jobSlider-right">
                          <Quotes
                            vat = {vat}
                            jobStatus={jobStatus}
                            requestDetails={requestDetails}
                            actions={this.props.actions}
                            jobRequestReducer={jobRequestReducer} />
                        </div>
                      </div>
                    </CustomScroll>
                  </div>
                </div>
                : (this.state.isSliderLoaded && unableToFetchPostedJobById)
                  ? <div style={{ 'height': "400px", 'textAlign': 'center', 'paddingTop': '40px' }}><div className="sliderHeader"><div className="slider-btn-right"><span className="jobSlider-close" onClick={this.props.modalCloseCallBack}><i className="mdi mdi-close" /></span></div></div><h3>Unable to fetch data <a style={{ cursor: 'pointer' }} onClick={(e) => { e.preventDefault; this.props.actions.getPostedJobById(this.state.currentSliderId) }}>Try Again</a></h3></div>
                  : <div style={{ 'height': "400px", 'textAlign': 'center', 'paddingTop': '40px' }}><div className="sliderHeader"><div className="slider-btn-right"><span className="jobSlider-close" onClick={this.props.modalCloseCallBack}><i className="mdi mdi-close" /></span></div></div><PageLoader /></div>
              }
            </div>
          </Draggable>
          <CustomModal className="decline-modal" showModal={this.state.showDeclineModal} footer="true" title="Decline Job" hideModal={() => this.setState({ showDeclineModal: false, declineReason: '' })} saveText="Decline" submitCallBack={this.declineJob.bind(this)}>
          <Modal.Body>
            <div>
              <span className="caption-result">Are you sure you want to Decline this Job?</span>
                  <div className="decline-txt-input">
                    <TextInput
                      type="text"
                      label="Comment"
                      name="Reason"
                      value={this.state.declineReason}
                      onChange={(text) => {
                        this.onDeclineReasonChange(text);
                      }}
                    />
                </div>
                {
                  this.state.showDeclineReasonErrTxt &&
                  <div className=''>
                    <span className="err-decline-txt">should be less than 201 characrers</span>
                  </div>
                }
                <div className="decline-reason-len-box">
                  <span className={this.state.declineReason.length > 200 ? 'err-decline-txt-len' : 'decline-txt-len'}>{this.state.declineReason.length ? this.state.declineReason.length : 0}/200</span>
                </div>
            </div>
          </Modal.Body>
          </CustomModal>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/JobSliderView/JobSliderView.jsx